module.exports = __webpack_public_path__ + "img/product-category-weddingrings.51db40c.webp";